module.exports = __webpack_public_path__ + "static/img/cp5.284d0a24.png";